//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cardPropertyMixin } from './CardPropertyMixin.js'

export default {
  name: 'CardSeparator',
  mixins: [cardPropertyMixin],
  props: {
    title: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    },
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  computed: {
    show: function () {
      return !this.tabProp || !this.tabProp._show || (!!this.object && this.tabProp._show(this.object))
    }
  }
}
